import { TestIDProps } from "@utils/typeUtils"
import { useEffect, useState } from "react"

interface DiscoDelayProps extends TestIDProps {
  component: React.ReactNode
  delay?: number
}

function DiscoDelay({ component, delay = 1000 }: DiscoDelayProps) {
  const [show, setShow] = useState(!delay)

  useEffect(() => {
    if (!delay) return
    const timer = setTimeout(() => {
      setShow(true)
    }, delay)
    return () => clearTimeout(timer)
  }, [delay])

  if (!show) return null

  return <>{component}</>
}

export default DiscoDelay
